import { render, staticRenderFns } from "./itemCard.vue?vue&type=template&id=5316058a&scoped=true"
import script from "./itemCard.vue?vue&type=script&lang=js"
export * from "./itemCard.vue?vue&type=script&lang=js"
import style0 from "./itemCard.vue?vue&type=style&index=0&id=5316058a&scoped=true&lang=css"
import style1 from "./itemCard.vue?vue&type=style&index=1&id=5316058a&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5316058a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2585860866/src/clients/ap3/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5316058a')) {
      api.createRecord('5316058a', component.options)
    } else {
      api.reload('5316058a', component.options)
    }
    module.hot.accept("./itemCard.vue?vue&type=template&id=5316058a&scoped=true", function () {
      api.rerender('5316058a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/menu/editor/bulkUpdate/itemCard.vue"
export default component.exports